import Vue from 'vue'
import VueStash from 'vue-stash';
import Contact from "./domain/contact";
import Address from "./domain/address";

Vue.use(VueStash);

export default {
    currentView: 'contact',
    language: 'en',
    translations: {},
    categories: [],
    countries: [],
    registration: {
        beers: [],
        company: new Address(),
        contact: new Contact(),
        hasDeputy: false,
        deputy: new Contact(),
        hasBilling: false,
        billing: new Address(),
        createUserAccount: true,
        password: "",
        vouchercode: "",
        interessent_id: null
    },
    additionalBeerCategoriesWithBeerType: [22, 23, 55, 56, 61],
}